type RowKeys = "message" | "breakpoint" | "label";

export const RowKeys: RowKeys[] = ["message", "breakpoint", "label"];

export interface BreakpointProps {
  index: number;
}
